import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap border-b text-darkgray-900 pb-7 mb-7 border-gray-40" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-2 gap-1" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Date Booked")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-right" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "January 24, 2023")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Time Booked")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-right" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "10:00 AM - 10:15 AM")
      ])
    ])
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 pl-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-2 gap-1" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Schedule Logs")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-right" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary-500" }, "Show")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1" }, [
        /*#__PURE__*/_createElementVNode("p", null, "Medical Questionnaire")
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "col-span-1 text-right" }, [
        /*#__PURE__*/_createElementVNode("p", { class: "font-bold text-primary-500" }, "View")
      ])
    ])
  ])
], -1)
const _hoisted_2 = { class: "flex items-center space-x-3 mb-7" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-wrap" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/2" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "border-b pb-7 mb-7 border-gray-40" }, [
      /*#__PURE__*/_createElementVNode("ul", { class: "pl-5 list-disc" }, [
        /*#__PURE__*/_createElementVNode("li", null, "Consultation/Counselling"),
        /*#__PURE__*/_createElementVNode("li", null, "Physical Exam"),
        /*#__PURE__*/_createElementVNode("li", null, "Eye/Hearing"),
        /*#__PURE__*/_createElementVNode("li", null, "Blood Exam (CBC, Blood Glucose /HbA1c, Lipid Profile, Liver)"),
        /*#__PURE__*/_createElementVNode("li", null, "Urinalysis"),
        /*#__PURE__*/_createElementVNode("li", null, "Fecalysis"),
        /*#__PURE__*/_createElementVNode("li", null, "Chest X-Ray"),
        /*#__PURE__*/_createElementVNode("li", null, "ECG")
      ])
    ]),
    /*#__PURE__*/_createElementVNode("p", { class: "mb-1 font-bold" }, "Doctor’s Notes:")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "w-1/2 pl-12" }, [
    /*#__PURE__*/_createElementVNode("div", { class: "rounded-[10px] bg-white py-7 px-5 text-darkgray-900" }, [
      /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-12 gap-2.5 border-b border-gray-40 pb-4 mb-4" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Branch")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", null, "Shinagawa BGC")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package"),
          /*#__PURE__*/_createElementVNode("p", { class: "pl-5 font-bold" }, "Add-on")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", null, "Japan Standard Health Checkup"),
          /*#__PURE__*/_createElementVNode("p", null, "N/A")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Date")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", null, "January 31, 2023")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Time")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", null, "10:00 AM - 10:15 AM")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Package Fee")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", null, "P21,000")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-4" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "font-bold" }, "Misc. Fees")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-8 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", null, "P1,500")
        ])
      ]),
      /*#__PURE__*/_createElementVNode("div", { class: "grid grid-cols-12 gap-2.5 text-primary-500" }, [
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-6" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "Total")
        ]),
        /*#__PURE__*/_createElementVNode("div", { class: "col-span-6 text-right" }, [
          /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "P20,500")
        ])
      ])
    ])
  ])
], -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "min-h-[calc(100vh-500px)]"
}
const _hoisted_7 = { class: "grid grid-cols-1 gap-4 lg:grid-cols-3 lg:gap-6" }
const _hoisted_8 = { class: "mt-12" }
const _hoisted_9 = {
  href: "/test-results",
  class: "flex items-center font-bold text-primary-500"
}

import PortalLayout from '@/layouts/PortalLayout.vue';
import ButtonComponent from '@/components/ButtonComponent.vue';
import { ChevronLeftIcon } from "@heroicons/vue/24/outline";
import TestResultCard from './TestResultCard.vue';

import { ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ViewPage',
  setup(__props) {

const tabSelected = ref('Information');


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(PortalLayout, {
    title: "Japan Standard Health Checkup",
    "hide-notification": true
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["px-5 py-2 text-sm font-bold leading-loose transition rounded-3xl", tabSelected.value == 'Information' ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white']),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (tabSelected.value = 'Information'))
        }, " Information ", 2),
        _createElementVNode("button", {
          type: "button",
          class: _normalizeClass(["px-5 py-2 text-sm font-bold leading-loose transition rounded-3xl", tabSelected.value == 'Test Results' ? 'bg-primary-500 text-white' : 'bg-zinc-40 text-primary-500 hover:bg-primary-500 hover:text-white']),
          onClick: _cache[1] || (_cache[1] = ($event: any) => (tabSelected.value = 'Test Results'))
        }, " Test Results ", 2)
      ]),
      (tabSelected.value == 'Information')
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
        : _createCommentVNode("", true),
      (tabSelected.value != 'Information')
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createVNode(TestResultCard, { badge: false }),
              _createVNode(TestResultCard, { badge: false }),
              _createVNode(TestResultCard, { badge: false }),
              _createVNode(TestResultCard, { badge: false })
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("a", _hoisted_9, [
          _createVNode(_unref(ChevronLeftIcon), { class: "w-4 h-4 mr-2" }),
          _createTextVNode(" Go back ")
        ])
      ])
    ]),
    _: 1
  }))
}
}

})